/**
 * Initials in a colour picked from the name, so the same tenant is always
 * the same colour and rows can be told apart at a glance.
 */
import { cn } from "@/lib/utils";

const TONES = [
  "bg-emerald-100 text-emerald-800 dark:bg-emerald-500/20 dark:text-emerald-300",
  "bg-sky-100 text-sky-800 dark:bg-sky-500/20 dark:text-sky-300",
  "bg-amber-100 text-amber-900 dark:bg-amber-500/20 dark:text-amber-300",
  "bg-violet-100 text-violet-800 dark:bg-violet-500/20 dark:text-violet-300",
  "bg-rose-100 text-rose-800 dark:bg-rose-500/20 dark:text-rose-300",
  "bg-teal-100 text-teal-800 dark:bg-teal-500/20 dark:text-teal-300",
];

export function NameAvatar({ name, className }: { name: string; className?: string }) {
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase())
    .join("");
  const hash = Array.from(name).reduce((sum, ch) => sum + ch.charCodeAt(0), 0);
  return (
    <span
      aria-hidden
      className={cn(
        "flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-xs font-semibold",
        TONES[hash % TONES.length],
        className,
      )}
    >
      {initials || "?"}
    </span>
  );
}
